import './HeadTitle.css'

function HeadTitle(){
    return (
        <>
        <section className="head-title-section">
            <h1 className="head-title-section-title">Nossos<span className='head-title-section-title-highlight'>Mentores</span></h1>
        </section>
        </>
    )
}

export default HeadTitle;